<template>
  <fvSelect
      class="form-control select text-right fv-size-md"
            v-model="valData"
            :options="users"
            :placeholder="placeholder"
            text-key="name"
            value-key="id"
            :search="true"
            :allowInsert="false"
            :multiple="multiple"
            @search="fetchData"
            :loading="loading"
  >

    <template slot="value" slot-scope="scope">
      {{findValueObject(scope.value).username}}
    </template>
    <template slot="option" slot-scope="scope">
      <div class="imageWithName">
            <span class="dropdown-item-text">
              <b>{{scope.option.username || "---"}} </b>
              <br>
              <small v-if="scope.option.name || scope.option.family_name">
                {{scope.option.name || ''}} {{scope.option.family_name || ''}}
              </small>
              <br>
              <small dir="ltr">{{scope.option.mobile}}</small>
            </span>

        <div class="dropdown-item-text">
          <img class="icon"
               v-if="scope.option.profile_picture && scope.option.profile_picture.path"
               :src="`${media_url}/${scope.option.profile_picture.path}?max=40`"/>

          <div v-else><i class="far fa-user-circle defaultIcon"/></div>
        </div>
      </div>
    </template>
  </fvSelect>
</template>

<script>
  import {mapActions} from "vuex"
  import {API_MEDIA_URL} from "../env"

  export default {
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String
      },
      id: {
        type: String
      },
      type: {
        type: String,
        default: null
      },
      selectByType: {
        type: Boolean,
        default: false
      },
      value: {
        type: [Array, String]
      },
      justId: {
        type: Boolean,
        default: false
      },
      required: [Boolean, Function],
    },
    data() {
      return {
        ...mapActions('main', [
          'crud'
        ]),
        users: [],
        loading: false,
        filters: {},
        timingFetch: null,
        media_url: API_MEDIA_URL
      }
    },
    created() {
      this.getData(true)
    },
    computed: {
      valData: {
        get() {
          return this.value ? this.justId ? [this.value] : this.value : this.multiple ? [] : undefined
        },
        set(value) {
          const data = this.multiple ? value : [value]
          const result = this.justId ? data[0] : data
          this.$emit('input', result)
        }
      }
    },
    methods: {
      async getData(first = false) {

        const filters = {}
        if (this.type) {
          if (this.selectByType)
            filters.type = this.type
          else
            filters.roles = this.type
        }


        if (first)
          if (this.value && this.value.length) {
            const $in = this.multiple ? this.value : [this.value]
            filters.id = {"$in": $in}
          }


        // if (this.filters.username)
        //   filters.username = this.filters.username

        try {
          const user = await this.crud({
            action: 'get',
            section: 'accounts',
            query: `${this.$queryGenerator(filters, '')}${this.filters.username ? `&q=${this.filters.username}` : ''}`,
            perPage: 5
          })

          const result = user.data.items
          this.users = []
          setTimeout(() => this.users = result , 500)
        } catch (e) {
          console.log(e)
        }
      },
      fetchData(event) {
        this.loading = true
        clearTimeout(this.timingFetch)
        this.timingFetch = setTimeout(async () => {

          if (!event.trim()) {
            this.users = []
            this.loading = false
            return false
          }
          this.filters.username = event
          await this.getData()
          setTimeout(() => this.loading = false , 1000)
        }, 2000)
      },
      findValueObject(value) {
        if (this.multiple)
          return this.users.find((option) => option.id === value) || false;
        else
          return this.users.find((option) => option.id === value[0]) || false;
      },

    }
  }
</script>

<style lang="scss">

</style>
